// extracted by mini-css-extract-plugin
export default {"Container":"GlobalNotification_Container__0gjbu","Info":"GlobalNotification_Info__fmiAd","Error":"GlobalNotification_Error__+BORt","Visible":"GlobalNotification_Visible__Hqq-0"};